import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import NewIcon from '@mui/icons-material/Add';
import { Skeleton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { addTrainingsItem, deleteTrainingsItem, getTrainings, updateTrainingsItem } from '../../../../actions/cv';
import TitledSection from '../../../common/TitledSection/TitledSection';
import CVBaseItem from '../../../common/CVBaseItem/CVBaseItem';
import classes from './scss/trainings.module.scss';
import AddEditCVRecord from '../../../common/ModalWindows/AddEditCVRecord';

function TrainingsAndCertificates() {
  const dispatch = useDispatch();
  const trainingsItems = useSelector((state) => state.cv?.trainings?.response);

  const [openAddWindow, setAddWindow] = React.useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getTrainings());
  }, []);

  const deleteHandler = (id) => {
    dispatch(deleteTrainingsItem(id));
  };

  const addTraining = async (training) => {
    dispatch(
      addTrainingsItem({
        CertificationType: training.type,
        CertificationId: training.certId,
        ValidUntil: training.valid ? dateFormat(training.valid, 'isoDate') : null,
        StartDate: null,
        EndDate: null
      })
    );
    setAddWindow(false);
  };

  const updateTraining = async (training) => {
    dispatch(
      updateTrainingsItem({
        Id: training.id,
        CertificationType: training.type,
        CertificationId: training.certId,
        ValidUntil: training.valid ? dateFormat(training.valid, 'isoDate') : null,
        StartDate: null,
        EndDate: null
      })
    );
  };

  return (
    <TitledSection
      title={t('profile.builder.details.training')}
      actions={
        <div className={classes.actionsWrapper}>
          <div className={classes.actionLabel}>
            <span>{t('common.general.save')}</span> <CheckIcon fontSize="8px" />
          </div>
          <NewIcon role="button" className={classes.action} onClick={() => setAddWindow(true)} />
        </div>
      }
    >
      <div className={classes.trainingsList}>
        {openAddWindow && (
          <AddEditCVRecord
            open
            closeHandler={() => setAddWindow(false)}
            editeMode={false}
            confirmHandler={addTraining}
            block="trainings"
            shouldImmediatelySave
          />
        )}
        {trainingsItems ? (
          trainingsItems?.map((item) => (
            <CVBaseItem
              key={item?.Id || new Date()}
              item={item}
              block="trainings"
              deleteItem={() => deleteHandler(item?.Id)}
              editItem={updateTraining}
              shouldImmediatelySave
            />
          ))
        ) : (
          <Skeleton animation="wave" width="100%" />
        )}
      </div>
    </TitledSection>
  );
}

export default TrainingsAndCertificates;
